export async function getPlayer({ userId, sessionId, organizationId }) {
  const params = new URLSearchParams({ userId, sessionId, organizationId });
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getPlayer?${params.toString()}`);

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to fetch player");
  }
  return data;
}
